import styled from 'styled-components';

export const UploadedFileInfo = styled.div(
    props =>`
    width: 100%;
    display: flex;
    border: 1px dashed ${props.theme.colors.black.light36};
    background-color: ${props.theme.colors.grey.light46};
    height: 4.2rem;
    border-radius: ${props.theme.misc.borderRadius.base};
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
  
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-top: ${props.theme.spacing.base};
      width: 100%;
      margin-left: ${props.theme.spacing.nospacing};
      height: 6rem;
    }
`);
  
export const ImageInfoWrap = styled.div`
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
  
export const CloseIcon = styled.p(
    props =>`
        width: 2rem;
        height: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        background-color: ${props.theme.colors.grey.lighte5};
        right: 0.2rem;
        top: 0.2rem;
        border-radius: ${props.theme.misc.borderRadius.round};
        font-size: ${props.theme.font.large.font13};
        color: ${props.theme.colors.black.base};
        padding-bottom: ${props.theme.spacing.small.s3};
        cursor: pointer;
`);

export const UploadImgMainText = styled.p(
    props => `
          display:inline-block;
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.grey.base};
          text-align:center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width:95%;
      `,
);

export const SubInfoText = styled.span(
    props => `
          font-size: 1.2rem ${props.theme.font.base};
          color: ${props.theme.colors.grey.light07};
          padding-top:${props.theme.spacing.small.s3};
      `,
);

export const DocumentTickWrap = styled.div(
    props =>`
    width: 1.4rem;
    height: 1.4rem;
    border-radius: ${props.theme.misc.borderRadius.round};
    background-color: ${props.theme.colors.green.base};
    position: absolute;
    z-index: ${props.theme.misc.zIndex.xxlarge};
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 0.6rem;
    right: 43%;
`);